export const apiPath = '/v2/cards';
const actionType = 'CARDS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
